/** Element is in viewport */
export function isInViewport(elem) {
  let elemBounding = elem.getBoundingClientRect();
  var elemHeight = elem.offsetHeight;
  var elemWidth = elem.offsetWidth;

  if (
    elemBounding.top >= -elemHeight &&
    elemBounding.left >= -elemWidth &&
    elemBounding.right <=
      (window.innerWidth || document.documentElement.clientWidth) + elemWidth &&
    elemBounding.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) + elemHeight
  ) {
    return true;
  } else {
    return false;
  }
}
export function lockScroll(state) {
  if (state == true) {
    $("body").addClass("body--lock");
    console.log("lock");
  } else {
    $("body").removeClass("body--lock");
    console.log("unlock");
  }
}

